module.exports = __webpack_public_path__ + "static/media/oneStar.1aace936.png";